export default "__VITE_ASSET__Bxo800xc__"